export default __webpack_public_path__ + "static/media/Victoria Typewriter Italic.9078d63d.ttf";